/**
 * Created by jaydip on 8/8/16.
 */
'use strict';
export default class AppService {
    constructor($http,$q) {
        'ngInject';
        this._$http = $http;
        this._$q = $q;

    }
    getAppKeys(){
        return [{key: '0', name: 'all'},
        {
            key:'UvzrbtC6b4Mn4Kth123',
            name:'iOS'
        },
        {
            key:'UvzrbtC6b4Mn4Kth',
            name:'Web'
        },
        {
            key:'UvzrbtC6b4Mn4Kth456',
            name:'Android'
        }];
    }
}



// WEBPACK FOOTER //
// ./src/app/app.service.js